import { render, staticRenderFns } from "./person.vue?vue&type=template&id=6e9f7ab1&scoped=true"
import script from "./person.vue?vue&type=script&lang=js"
export * from "./person.vue?vue&type=script&lang=js"
import style0 from "./person.vue?vue&type=style&index=0&id=6e9f7ab1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f7ab1",
  null
  
)

export default component.exports